import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing';
import BugCrowdCredentialsForm from './BugCrowdCredentialsForm';
import BugCrowdMappingForm from './BugCrowdMappingForm';

export default function BugCrowdConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={BugCrowdMappingForm}
            CredentialsForm={BugCrowdCredentialsForm}
            componentName="Program Name"
            componentKey="programName"
        />
    )
}